<template>
	<div>
    <base-header type="gradient-danger" class="pb-6 pb-8 pt-5 pt-md-8">
		</base-header>
		<div class="container-fluid mt--9">
			<div class="col-12 mb-3 mb-xl-0">
				<div class="card shadow">
					<div>
						<div class="card-header bg-transparent">
              <div class="d-flex">
                <div class="flex-grow-1">
                  <h3 class="mb-1 d-flex align-items-center">
                    Crear nueva Factura de Anticipo
                  </h3>
                </div>
              </div>
						</div>
						<div class="card-body">
              <div class="row pl-4">
								<div class="col-12">
									<label class="form-control-label">Cliente *</label>
									<multiselect
										v-model="selectedCustomer"
										placeholder="Buscar Cliente"
										:options="customers ? customers : []"
										class="mb-4"
                    :custom-label="x => {return `${x.CardCode} - ${x.CardName}`}"
                    :loading="!customers"
                    :disabled="!customers"
                    @select="getCustomer"
                    :allow-empty="false"
                    >
									</multiselect>
								</div>

								<div class="col-6 col-xl-3">
									<base-input
										:value="customer ? customer.FederalTaxID : null"
										inputClasses="input-group-alternative"
										label="RFC"
										placeholder="RFC"
										disabled
                    required>
									</base-input>
								</div>

								<div class="col-6 col-xl-3">
                  <base-input
                    :value="customer && customer.U_TS_RegFiscal && regimenes ? regimenes.find(x => x.Code === customer.U_TS_RegFiscal).Name: null"
                    inputClasses="input-group-alternative"
                    label="Régimen Fiscal"
                    placeholder="Régimen Fiscal"
                    disabled
                    required>
                  </base-input>
                </div>

								<div class="col-6 col-xl-3">
                  <base-input
                    :value="customer ? customer.U_TS_UsoSN : null"
                    inputClasses="input-group-alternative"
                    label="Uso CFDI"
                    placeholder="Uso CFDI"
                    disabled
                    required>
                  </base-input>
                </div>

                <div class="col-6 col-xl-3">
									<label class="form-control-label">Almacén *</label>
									<multiselect
										v-model="selectedWarehouse"
										placeholder="Almacén"
										:options="warehouses"
										class="mb-4"
                    @select="selectWhse"
                    :disabled="!customer || loadingCustomer"
                    :loading="loadingCustomer"
                    :show-labels="false"
                  >
									</multiselect>
								</div>

                <div class="col-6 col-xl-3">
                  <base-input
                    :value="zipCode"
                    inputClasses="input-group-alternative"
                    label="C. P. de Almacén"
                    placeholder="C. P. de Almacén"
                    disabled
                    required>
                  </base-input>
                </div>

								<div class="col-6 col-xl-3">
                  <base-input
                    :value="customer && salesPersonOptions ? salesPersonOptions.find(x => x.SalesEmployeeCode === customer.SalesPersonCode).SalesEmployeeName : null"
                    inputClasses="input-group-alternative"
                    label="Vendedor"
                    placeholder="Vendedor"
                    disabled
                    required>
                  </base-input>
                </div>

                <div class="col-6 col-xl-3">
									<label class="form-control-label">Persona de contacto</label>
									<multiselect
										v-model="selectedContact"
										placeholder="Persona de contacto"
                    track-by="InternalCode"
										:options="customer ? customer.ContactEmployees : []"
										class="mb-4"
                    :disabled="!customer || loadingCustomer"
                    :loading="loadingCustomer"
                    :show-labels="false"
                    :custom-label="x => {return `${x.Name} - ${x.Phone1 ? x.Phone1 : x.E_Mail}`}"
                    >
									</multiselect>
								</div>
                <div class="col-6 col-xl-3">
                  <base-input
                    :value="customer && selectedPaymentMethod.PaymentMethodCode"
                    inputClasses="input-group-alternative"
                    label="Vía de Pago"
                    placeholder="Vía de Pago"
                    disabled
                    required>
                  </base-input>
                <!-- <label class="form-control-label">Vía de Pago *</label>
									<multiselect
										v-model="selectedPaymentMethod"
										placeholder="Vía de Pago"
										:options="customer ? customer.BPPaymentMethods.filter(x => x.PaymentMethodCode !== '15') : []"
										class="mb-4"
                    label="PaymentMethodCode"
                    track-by="PaymentMethodCode"
                    :disabled="!customer || loadingCustomer"
                    :loading="loadingCustomer"
                    >
									</multiselect> -->
								</div>

                <div class="col-6 col-xl-3">
                  <base-input
                    :value="selectedPaymentMethod ?
                        selectedPaymentMethod.PaymentMethodCode === '99' ? 'PPD' : 'PUE'
                        : null"
                    inputClasses="input-group-alternative"
                    label="Método de Pago"
                    placeholder="Método de Pago"
                    disabled
                    required>
                  </base-input>
                </div>

                <div class="col-6 col-xl-3">
                  <base-input
                    :value="paymentGroup ? paymentGroup.PaymentTermsGroupName : null"
                    inputClasses="input-group-alternative"
                    label="Condiciones de pago"
                    placeholder="Condiciones de pago"
                    disabled
                    required>
                  </base-input>
                </div>

                <div class="col-6 col-xl-3">
									<label class="form-control-label">Moneda *</label>
                  <multiselect
                    v-model="selectedCurrency"
                    placeholder="Moneda"
                    :options="currencies"
                    class="mb-4"
                    :disabled="!currencies || !customer || (customer && customer.Currency !== '##') || loadingCustomer"
                    :loading="loadingCustomer"
                    :show-labels="false"
                    >
                  </multiselect>
                </div>

                <div class="col-6 col-xl-3">
                  <base-input
                    v-model="reference"
                    inputClasses="input-group-alternative"
                    label="Referencia"
                    placeholder="Referencia"
                    :disabled="!customer || loadingCustomer">
                  </base-input>
                </div>

                <div class="col-6 col-xl-3" v-if="globalInformation">
                  <base-input
                    :value="globalInformation.periodicity"
                    inputClasses="input-group-alternative"
                    label="Periodicidad"
                    placeholder="Periodicidad"
                    disabled>
                  </base-input>
                </div>
                <div class="col-6 col-xl-3" v-if="globalInformation">
                  <base-input
                    :value="globalInformation.months"
                    inputClasses="input-group-alternative"
                    label="Meses"
                    placeholder="Meses"
                    disabled>
                  </base-input>
                </div>
                <div class="col-6 col-xl-3" v-if="globalInformation">
                  <base-input
                    :value="globalInformation.year"
                    inputClasses="input-group-alternative"
                    label="Año"
                    placeholder="Año"
                    disabled>
                  </base-input>
                </div>

                <div class="col-12 d-flex px-0 my-1">
                  <div class="col-12 col-xl-6">
                    <base-input
                      :value="billTo"
                      inputClasses="input-group-alternative"
                      label="Dirección"
                      placeholder="Dirección"
                      disabled
                      required>
                    </base-input>
                  </div>

                  <div class="col-12 col-xl-6">
                    <label class="form-control-label">Enviar a *</label>
                    <multiselect
                      v-model="selectedShipTo"
                      placeholder="Enviar a"
                      :options="customer ? customer.BPAddresses.filter(x => x.AddressType === 'bo_ShipTo') : []"
                      class="mb-4"
                      :disabled="!customer || loadingCustomer"
                      :loading="loadingCustomer"
                      :show-labels="false"
                      :custom-label="x => {
                        return `${x.AddressName} - ${[
                          x.Street,
                          x.StreetNo,
                          x.BuildingFloorRoom,
                          x.Block,
                          x.ZipCode,
                          x.City,
                          x.State,
                          x.Country
                        ].filter(x => x).join(', ')}`}"
                      >
                    </multiselect>
                  </div>
                </div>
            </div>
          </div>
            <div>



              <h6 class="heading-small text-muted mb-4 pl-4">Artículos</h6>
              <div class="table-responsive" v-if="docLines">
                <base-table thead-classes="thead-light" :data="docLines">
                  <template #columns>
                    <th width="40%" class="pl-5">Artículo</th>
                    <th width="10%" class="text-right">Cantidad</th>
                    <th width="10%" >U. medida</th>
                    <th width="10%" class="text-center">Precio Unitario *</th>
                    <th width="10%" class="text-right">Total</th>
                  </template>
                  <template #default="{ row }">
                    <td scope="row" width="40%" class="pl-5">
                      <b> {{row.itemCode}}</b>
                      {{row.itemDescription}}
                    </td>
                    <td scope="row" width="10%" class="text-right">
                      {{ row.quantity }}
                    </td>
                    <td scope="row" width="10%">
                      {{ row.measureUnit }}
                    </td>
                    <td scope="row" width="10%" class="text-center">
                      <div class="d-flex justify-content-center w-100">
                        <base-input
                          v-model="row.unitPrice"
                          inputClasses="input-group-alternative"
                          placeholder="Precio Unitario *"
                          class="m-0"
                          type="number"
                          style="width: 170px;"
                          :disabled="!customer || loadingCustomer">
                        </base-input>
                      </div>
                    </td>
                    <td scope="row"  width="10%" class="text-right">
                      {{ currencyFormat((row.unitPrice ? parseFloat(row.unitPrice) : 0) * row.quantity, currencyIso) }}
                    </td>
                  </template>
                </base-table>
              </div>
              <hr class="my-0">
              <div class="d-flex w-100 justify-content-between align-items-end modal-body py-0">
                <div class="pl-4 my-1 d-flex 0">
                  <base-input
                    v-model="comments"
                    inputClasses="input-group-alternative"
                    label="Comentarios"
                    placeholder="Comentarios"
                    style="width: 400px;"
                    :disabled="!customer || loadingCustomer"
                    >
                  </base-input>

                  <div class="ml-4">
                    <label class="form-control-label">Referencia Saldo a Favor *</label>
                    <multiselect
                      v-model="importFileNum"
                      placeholder="Selecciona un folio"
                      :custom-label="(x) => 'Cobro #' + x.Folio"
                      :options="balanceFavorOptions ? balanceFavorOptions : []"
                      track-by="Folio"
                      :show-labels="false"
                      style="width: 400px;"
                      >
                    <template slot="option" slot-scope="props">
                      <div>
                        <span><b>Cobro #{{ props.option.Folio }} </b></span>
                        <span> - </span>
                        <span class="text-xs bold">Total:  </span>
                        <b>
                          {{currencyFormat(
                            props.option.Moneda === 'MXP' ? props.option.DocTotalSy : props.option.DocTotalFC, 
                            props.option.Moneda
                          )}}
                        </b>
                        <span> - </span>
                        <span class="text-xs bold">Saldo Pendiente: </span>
                        <b>
                          {{ currencyFormat(props.option["Saldo Pendiente"], props.option.Moneda) }}
                        </b>
                      </div>
                    </template>
                    </multiselect>
                    <span class="text-xs" v-if="balanceFavorOptions && !balanceFavorOptions.length">
                      No hay folios. Solicita ayuda al departamento de cobranza
                    </span>
                  </div>

                </div>
              <div class="d-flex justify-content-end" v-if="docLines.length">
                <table class="text-right text-sm">
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Subtotal</h5></th>
                    <td>
                      {{ currencyFormat(docLines.reduce((acc, x) => acc + (x.unitPrice ? parseFloat(x.unitPrice) : 0) * x.quantity, 0), currencyIso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">IVA</h5></th>
                    <td>
                      {{ currencyFormat((docLines.reduce((acc, x) => acc + (x.unitPrice ? parseFloat(x.unitPrice) : 0) * x.quantity, 0)) * 0.16, currencyIso) }}
                    </td>
                  </tr>
                  <tr>
                    <th class="pr-4"><h5 class="my-1">Total</h5></th>
                    <td>
                      {{ currencyFormat((docLines.reduce((acc, x) => acc + (x.unitPrice ? parseFloat(x.unitPrice) : 0) * x.quantity, 0)) * 1.16, currencyIso ) }}
                    </td>
                  </tr>
                </table>
              </div>
              </div>
            </div>

            <div class="d-flex justify-content-between align-items-center mt-4 card-footer">
              <base-checkbox v-model="stamp" :disabled="stampDisabled" class="flex-shrink-0">
                Timbrar ante el SAT
              </base-checkbox>
              <div v-if="!creating" v-b-popover.hover.focus.top.html="popoverData">
                <base-button
                  @click="createInvoice()"
                  icon="fas fa-check"
                  :disabled="!validation.valid"
                  >
                  Facturar
                </base-button>
              </div>
              <base-loader v-if="creating" text="Facturando. Espere un momento..." class="flex justify-items-center w-100"/>
            </div>
					</div>
				</div>
			</div>
		</div>
  </div>
</template>

<script>
import axios from 'axios'
import BaseLoader from '@/components/BaseLoader.vue';
import moment from "moment";
// import md5 from "md5-hash";
import { getAuth } from "firebase/auth";
import Multiselect from 'vue-multiselect'
import currency from '@/data/currency.json'
import posthog from 'posthog-js';
import Formats from "@/mixins/Formats";

  export default {
    mixins: [Formats],
    components:{
      BaseLoader,
      Multiselect
    },
    data() {
      return {
        HANA_URL: process.env.VUE_APP_HANA_URL,
        user: null,
        customers: null,
        customer: null,
        selectedCustomer: null,
        selectedWarehouse: null,
        warehouses:["CUU-02", "MEX-02", "GDL-02", "QRO-02", "MTY-02", "MID-02"],
        selectedPaymentMethod: null,
        selectedContact: null,
        zipCode: null,
        paymentGroup: null,
        currencies: ["MXP","USD","EUR"],
        selectedCurrency: null,
        reference: null,
        globalInformation: null,
        selectedShipTo: null,
        billTo: null,
        comments: null,
        docLines: [
            {
              itemCode: 'ANTICIPO',
              itemDescription: 'Anticipo del bien o Servicio',
              quantity: 1,
              measureUnit: 'ACT',
              U_TS_ObjetoImpFact:"02",
              unitPrice: null,
              total: null,
            }
          ],
        loadingCustomer: false,
        regimenes: null,
        salesPersonOptions: null,
        facturama: null,
        creating: false,
        stamp: false,
        stampDisabled: true,
        balanceFavorOptions: null,
        importFileNum: null,
        invoicingPermission: false,
      }
    },

    methods: {
      getCustomer(customer){
        this.loadingCustomer = true;

        this.customer = null;
        this.selectedWarehouse = null;
        this.selectedContact = null;
        this.selectedCurrency = null;
        this.selectedShipTo = null;
        this.globalInformation = null;
        this.zipCode = null;
        this.billTo = null;
        this.paymentGroup = {
          "GroupNumber": 8,
          "PaymentTermsGroupName": "Contado"
        };
        this.selectedPaymentMethod = { PaymentMethodCode : '03'};
        this.balanceFavorOptions = null;
        this.importFileNum = null;
        this.invoicingPermission = false;

        axios.get(`/api/customers/${customer.CardCode}`)
        .then(response => {
          this.customer = response.data;

          let query = {
            select: "*",
            table: "@USTI",
            where: `WHERE "U_Email" = '${this.user.email}'`
          };
          
          axios.post(`${this.HANA_URL}/api/hana/basic_general_query`, query)
          .then(res => {
            if(res.data && res.data.length){
              const customerCEDIS = this.customer.U_CEDIS;
              if(
                ["FA","FA_NC"].includes(res.data[0].U_DocumentType) && 
                res.data[0].U_Warehouse &&
                res.data[0].U_Warehouse.split(",").some(whse => whse.startsWith(customerCEDIS))
              ){
                this.invoicingPermission = true;
              }
            }
          }).catch(err => {
            console.error(err); 
          });

          if(this.customer.CardCode === 'C02858'){
            this.stamp = false;
            this.stampDisabled = true;
          } else {
            this.stamp = true;
            this.stampDisabled = false;
          }

          this.selectedWarehouse = `${this.customer.U_CEDIS}-02`;
          this.selectWhse(this.selectedWarehouse);

          // axios.get(`/api/paymentsByCode?code=${this.customer.PayTermsGrpCode}`)
          // .then(res => {
          //   this.paymentGroup = res.data.value.find(x => x.GroupNumber === this.customer.PayTermsGrpCode);
          // }).catch(err => {
          //   console.error(err); 
          // });

          if(this.customer.BPAddresses.filter(x => x.AddressType === 'bo_ShipTo').length === 1){
            this.selectedShipTo = this.customer.BPAddresses.find(x => x.AddressType === 'bo_ShipTo');
          }

          if(this.customer.Currency !== "##"){
            this.selectedCurrency = this.customer.Currency;
          }

          if(this.customer.FederalTaxID === "XAXX010101000"){
            this.globalInformation = {
              periodicity: "01",
              months: moment().format('MM'),
              year: moment().format('YYYY')
            }
          }
          let ad = this.customer.BPAddresses.find(x => x.AddressType === 'bo_BillTo');
          this.billTo = `${ad.AddressName} - ${[ad.Street,
                                                ad.StreetNo,
                                                ad.BuildingFloorRoom,
                                                ad.Block,
                                                ad.ZipCode,
                                                ad.City,
                                                ad.State,
                                                ad.Country].filter(x => x).join(', ')}`;
          this.docLines = [
            {
              itemCode: 'ANTICIPO',
              itemDescription: 'Anticipo del bien o Servicio',
              quantity: 1,
              measureUnit: 'ACT',
              unitPrice: null,
              total: null,
            }
          ];
        }).catch(error => {
          console.error(error);
        }).finally(() => {
          this.loadingCustomer = false;
        });

        const query = {
          "select": "*",
          "table": "UnreconciledPaymentsView",
          "where": `WHERE "CardCode" = '${customer.CardCode}'`
        };
        
        axios.post(`${this.HANA_URL}/api/hana/basic_general_query`, query)
        .then(res => {
          this.balanceFavorOptions = res.data;
        }).catch(err => {
          console.error(err); 
        });

      },
      selectWhse(params){
        axios.get(`api/warehouses/${params}`)
        .then(res => {
          this.zipCode = res.data.value[0].ZipCode
        }).catch(err => {
          console.error(err);
        });
      },
      createInvoice(){
        this.creating = true;
        let items = this.docLines.map(item => {

          let subTotal = (parseFloat(item.unitPrice) * item.quantity);
          let linea = {
            ProductCode: "84111506",
            IdentificationNumber: item.itemCode,
            Description: item.itemDescription,
            UnitCode: item.measureUnit,
            UnitPrice: parseFloat(item.unitPrice).toFixed(6),
            Quantity: item.quantity,
            Subtotal: subTotal.toFixed(6),
            TaxObject: "02",
            Total: (subTotal * 1.16).toFixed(6),
            Taxes: [
              {
                "Total": (subTotal * 0.16).toFixed(6),
                "Name": "IVA",
                "Base": subTotal.toFixed(6),
                "Rate": 0.16,
                "IsRetention": false
              }
            ],
          }
          return linea;
        });

        let taxZipCode;
        if(["XAXX010101000", "XEXX010101000"].includes(this.customer.FederalTaxID)){
          taxZipCode = this.zipCode;
        } else {
          taxZipCode = this.customer.BPAddresses.find(x => x.AddressType === 'bo_BillTo').ZipCode;
        }
        
        this.facturama = {
          "CfdiType": "I",
          "PaymentForm": this.selectedPaymentMethod.PaymentMethodCode,
          "PaymentMethod": this.selectedPaymentMethod.PaymentMethodCode === '99' ? 'PPD' : 'PUE',
          "ExpeditionPlace": this.zipCode,
          "Date": moment().format('YYYY-MM-DD'),
          "PaymentConditions": this.paymentGroup.PaymentTermsGroupName, 
          "Exportation": "01",
          "Items": items,
          "GlobalInformation": this.globalInformation ? this.globalInformation : null,
          "Receiver": {
            "Rfc": this.customer.FederalTaxID,
            "CfdiUse": this.customer.U_TS_UsoSN,
            "Name": this.customer.CardName,
            "FiscalRegime": this.customer.U_TS_RegFiscal,
            "TaxZipCode": taxZipCode
          },
        }

        if(this.selectedCurrency !== 'MXP'){
          let date = moment().format('YYYYMMDD');
          axios.get(`api/getCurrencies?date=${date}`)
          .then(res => {
            this.facturama.CurrencyExchangeRate = res.data[this.selectedCurrency];
            this.facturama.Currency = this.selectedCurrency;
            this.sap();
          })
          .catch(err => {
            console.error(err);
            this.creating = false;
          });
        } else {
          this.sap();
        }

      },
      sap() {
        let documentLines = this.docLines.map((item) => {
          return {
            ItemCode: item.itemCode,
            Quantity: item.quantity,
            Price: parseFloat(item.unitPrice).toFixed(6),
            UnitPrice: parseFloat(item.unitPrice).toFixed(6),
            Currency: this.selectedCurrency,
            WarehouseCode: this.selectedWarehouse,
          }
        });

        let sap = {
          "CardCode": this.customer.CardCode,
          "DocCurrency": this.selectedCurrency,
          "PaymentMethod": this.selectedPaymentMethod.PaymentMethodCode,
          "DownPaymentType": "dptInvoice",
          "PaymentGroupCode": this.customer.PayTermsGrpCode,
          "U_TS_ActStatus": "N",
          "U_TS_GenType": "N",
          "U_TS_DEQ": null,
          "DocumentLines": documentLines,
          "U_WebUser": this.user.email,
          "U_Web": "Y",
          "ContactPersonCode": this.selectedContact ? this.selectedContact.InternalCode : null,
          "NumAtCard": this.reference,
          "ShipToCode": this.selectedShipTo.AddressName,
          "Comments": this.comments,
          "U_TS_UsoCFDI40": this.customer.U_TS_UsoSN,
          "U_WebTimbrado": this.stamp ? "Y" : "N",
          "ImportFileNum": this.importFileNum.Folio,
        };

        let emails;
        if(process.env.NODE_ENV === 'production'){
          emails = this.customer.ContactEmployees
          .filter((contacto) => contacto.U_TS_EnvioCorreo === "SI" && contacto.E_Mail)
          .map((contacto) => contacto.E_Mail);
        } else {
          emails = [this.user.email];
        }

        let body = {
          facturoporti: this.facturama,
          sap,
          emails,
          type: "anticipo",
          timbrado: this.stamp,
        };
        console.log("JSON to INVOICE", body)

        axios.post(`api/fpt/invoice`, body)
        .then(res => {
          console.log("🟦 INVOICE RESPONSE", res);

          if(res.data.DocNum){
            this.$swal("Factura creada", `La factura #${res.data.DocNum} ha sido creada`, "success")
            .then(() => {
              this.$router.push(`/advanceInvoice/${res.data.DocNum}`);
            });
          } else {
            if(process.env.NODE_ENV === 'production'){
              posthog.capture('AdvanceInvoiceError', res);
            }
            if(res.data.error){
              if(res.data.error.error){
                if(res.data.error.error.code === -5002){
                  this.$swal("Error", "Este cliente no tiene la opción de pago 03 activa, por favor solicítalo a cobranza", "error")
                } else {
                  this.$swal("Error", res.data.error.error.message.value, "error")
                }
              } else if(res.data.error.Message){
                this.$swal("Error", res.data.error.Message, "error")
              } else {
                this.$swal('Error', "Algo salió mal, por favor antes de reintentar verifica si fue creado correctamente y da aviso a soporte", 'error');
                console.error("Error", res);
              }
            } else if (res.data.msg){
              this.$swal("Error", res.data.msg, "error");
            } else {
              this.$swal('Error', 'Algo salió mal, por favor antes de reintentar verifica si fue creado correctamente y da aviso a soporte', 'error');
              console.error("Error", res);
            }
          }
        }).catch(err => {
          console.error(err);
          this.$swal('Error', "Algo salió mal, por favor antes de reintentar verifica si fue creado correctamente y da aviso a soporte", 'error');
        }).finally(() => {
          this.creating = false;
        });

      },
    },
    created(){
      this.user = getAuth().currentUser;

      axios.get(`/api/customers`)
      .then(response => {
        this.customers = response.data.value;
      }).catch(error => {
        console.error(error);
      });

      axios.get(`/api/regimen_fiscal`)
      .then(res => {
        this.regimenes = res.data;
      }).catch(err => {
        console.error(err);
      });

      axios.get(`/api/sales_persons`)
      .then((response) => {
        this.salesPersonOptions = response.data.value;
      }).catch((error) => {
        console.error(error);
      });

    },
    computed:{
      currencyIso(){
        if(this.selectedCurrency){
          return currency.find(x => x.key === this.selectedCurrency).iso;
        } else {
          return 'MXN';
        }
      },
      validation() {
        if(!this.customer){
          return {
            valid: false,
            missing: ['Cliente']
          }
        }
        const { FederalTaxID, U_TS_RegFiscal, U_TS_UsoSN, SalesPersonCode } = this.customer;
        const complete = {
          "No tienes permiso para crear esta factura": this.invoicingPermission,
          "RFC": FederalTaxID,
          "Régimen Fiscal": U_TS_RegFiscal,
          "Uso CFDI": U_TS_UsoSN,
          "Almacén": this.selectedWarehouse,
          "Código Postal": this.zipCode,
          "Vendedor": SalesPersonCode,
          "selectedPaymentMethod": this.selectedPaymentMethod,
          "Condiciones de pago": this.paymentGroup,
          "Moneda": this.selectedCurrency,
          "Enviar a": this.selectedShipTo,
          "Precio Unitario": this.docLines[0].unitPrice,
          "Referencia Saldo a Favor": this.importFileNum,
        };
        return {
          valid: Object.values(complete).every((x) => x),
          missing: Object.keys(complete).filter((x) => !complete[x]),
        };
      },
      popoverData() {
        if (this.validation.missing.length > 0) {
          return {
            title: "<small><b>Verifica los siguientes campos:</b></small>",
            content: `<ul><li>${this.validation.missing.join("<li>")}</ul>`,
            placement: "righttop",
          };
        } else {
          return null;
        }
      },
    }

  }
</script>

<style lang="scss" scoped>

</style>